const types = {
  SET_USER: 'SET_USER',
  SET_PROFILE: 'SET_PROFILE',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations-types.js